import { render, staticRenderFns } from "./commonReportList.vue?vue&type=template&id=9ffa70ca&scoped=true"
import script from "./commonReportList.vue?vue&type=script&lang=js"
export * from "./commonReportList.vue?vue&type=script&lang=js"
import style0 from "./commonReportList.vue?vue&type=style&index=0&id=9ffa70ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffa70ca",
  null
  
)

export default component.exports